/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconAISearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconAISearch"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.04 3.04c.833 0 1.64.115 2.406.327L13.95 4.6l-1.187.477a7 7 0 1 0 6.258 6.478l.54-1.345 1.18-.475c.194.736.298 1.508.298 2.305a8.97 8.97 0 0 1-2.437 6.155l3.087 3.087-1.416 1.414-3.197-3.197A9 9 0 1 1 12.04 3.039"
    />
    <path
      fill="currentColor"
      d="M17.78 5.51c.16.39.48.72.87.87l2.53 1.02-2.53 1.02c-.39.16-.72.48-.87.87l-1.02 2.53-1.02-2.53a1.58 1.58 0 0 0-.87-.87L12.34 7.4l2.53-1.02c.39-.16.72-.48.87-.87l1.02-2.53zM20.999 1.73c.13.53.54.96 1.08 1.08l1.31.41-1.32.41c-.53.13-.96.54-1.08 1.08l-.41 1.31-.41-1.32a1.45 1.45 0 0 0-1.08-1.08l-1.31-.41 1.32-.41c.53-.13.96-.54 1.08-1.08l.41-1.31z"
    />
  </svg>
);
export default IconAISearch;
